<template>
  <v-dialog v-model="dialog" scrollable persistent max-width="35vw">
    <v-form ref="scenarioBuilderForm" v-model="formValid" @submit.prevent>
      <v-card outlined>
        <v-card-title class="bg_dark dw_green--text font-weight-light">
          <v-icon color="dw_green" class="mr-2" v-text="mdiFileDocumentEditOutline" />
          Attachment Details
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-0">
          <v-select
            v-model="classification"
            :items="classificationOptions"
            label="Classification"
            placeholder="Add a classification for your attachment"
            color="dw_green"
            outlined
            shaped
            dense
            item-color="dw_green"
            item-text="name"
            return-object
            hide-details
            clearable
            class="my-5"
          ></v-select>
          <v-text-field
            v-model="name"
            label="Test Scenario Name"
            placeholder="Test Scenario I"
            :rules="[vRules.min, vRules.textRegex]"
            :hide-details="vRules.min(name) && vRules.textRegex(name)"
            color="dw_green"
            outlined
            shaped
            dense
            class="my-5"
          ></v-text-field>
          <v-textarea
            v-model="description"
            label="Description"
            placeholder="Short description of the scenario"
            :rules="[vRules.min, vRules.textRegex]"
            :hide-details="vRules.min(description) && vRules.textRegex(description)"
            color="dw_green"
            outlined
            shaped
            dense
            rows="3"
            row-height="15"
            class="my-5"
          ></v-textarea>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="bg_dark">
          <v-btn
            small
            text
            color="grey"
            @click="dialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            small
            text
            color="dw_green"
            :disabled="!formValid"
            @click="updateDetails">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mdiFileDocumentEditOutline } from '@mdi/js';
import utils from '@/utils/index';

export default {
  name: 'scenarioForm',
  data() {
    return {
      mdiFileDocumentEditOutline,
      dialog: false,
      formValid: false,
      classificationOptions: ['UNCLASSIFIED', 'UNCLASSIFIED//FOUO', 'CUI'],
      classification: '',
      name: '',
      description: '',
      vRules: utils.validationRules
    };
  },
  watch: {
    classification() {
      if (!this.classification) this.classification = '';
    }
  },
  computed: {
    ...mapGetters([
      'scenarioBuilder'
    ])
  },
  methods: {
    ...mapActions([
      'updateScenarioBuilder'
    ]),
    openModal() {
      this.classification = this.scenarioBuilder.classification;
      this.name = this.scenarioBuilder.name;
      this.description = this.scenarioBuilder.description;
      this.dialog = true;
    },
    updateDetails() {
      this.updateScenarioBuilder(['details', {
        classification: this.classification,
        name: this.name,
        description: this.description
      }]);
      this.dialog = false;
    }
  }
};
</script>
